import { render, staticRenderFns } from "./SAccTopLayout.vue?vue&type=template&id=025d8898&scoped=true"
import script from "./SAccTopLayout.vue?vue&type=script&lang=ts"
export * from "./SAccTopLayout.vue?vue&type=script&lang=ts"
import style0 from "./SAccTopLayout.vue?vue&type=style&index=0&id=025d8898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025d8898",
  null
  
)

export default component.exports